module.exports = __webpack_public_path__ + "08244640b4737284bc196921cfe17a45.svg";